import { Box } from "@mui/material";
import { Sidebar } from "./components/Sidebar";
import CustomApp from "./view/CustomApp";
import { ResizableContainer } from "../../../../shell/components/ResizeableContainer";
export const MarketplaceWrapper = () => {
  return <Box sx={{
    color: "text.primary",
    backgroundColor: "background.paper",
    height: "100%",
    display: "flex",
    "*": {
      boxSizing: "border-box"
    }
  }} data-sentry-element="Box" data-sentry-component="MarketplaceWrapper" data-sentry-source-file="index.tsx">
      <ResizableContainer id="appsNav" defaultWidth={220} minWidth={220} maxWidth={360} data-sentry-element="ResizableContainer" data-sentry-source-file="index.tsx">
        <Sidebar data-sentry-element="Sidebar" data-sentry-source-file="index.tsx" />
      </ResizableContainer>
      <CustomApp data-sentry-element="CustomApp" data-sentry-source-file="index.tsx" />
    </Box>;
};